import { executeAction } from './global.actions'
import AnexosService from 'src/services/anexos.service'

export const actions = {
  DOWNLOAD_FACTURA: 'DOWNLOAD_FACTURA',
  DOWNLOAD_CREDITO_FISCAL: 'DOWNLOAD_CREDITO_FISCAL',
}

export const downloadFactura =
  (params: { start: number; end: number }) => async dispatch => {
    const process = async () => ({
      response: await AnexosService.downloadAnexo(2, params),
    })
    dispatch(executeAction(actions.DOWNLOAD_FACTURA, process))
  }

export const downloadCreditoFiscal =
  (params: { start: number; end: number }) => async dispatch => {
    const process = async () => ({
      response: await AnexosService.downloadAnexo(1, params),
    })
    dispatch(executeAction(actions.DOWNLOAD_CREDITO_FISCAL, process))
  }
